import { render, staticRenderFns } from "./AuthorizationDocument.vue?vue&type=template&id=2abe0c9f&scoped=true"
import script from "./AuthorizationDocument.vue?vue&type=script&lang=js"
export * from "./AuthorizationDocument.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationDocument.vue?vue&type=style&index=0&id=2abe0c9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abe0c9f",
  null
  
)

export default component.exports